<template>

	<nav id="main-nav">
		<router-link to="/" class="logo">Home</router-link>
		<ul>
			<li class="create-button-container" @click.prevent="clickedCreateButton" title="New Page">
				<a href="#" id="create-button" title="New Page">add</a>
			</li>
			<li @click.prevent="clickedUpdatesButton" title="Updates">
				<a href="#" id="updates-button" title="Updates">history</a>
			</li>
			<li @click.prevent="clickedSearchButton" title="Search">
				<a href="#" title="Search">search</a>
			</li>
			<li v-if="loggedIn" @click.prevent="logout()" :title="`Logged in as ${loggedInFullName}`">
				<a href="#" :title="`Logged in as ${loggedInFullName}`">lock_open</a>
			</li>
			<li v-else @click.prevent="clickedLoginButton" title="Log in">
				<a id="login-button" title="Log in">lock</a>
			</li>
		</ul>
		<popover okButtonName="Create" v-on:clicked-ok="finishedCreatePopover" ref="createPopover">
			<label for="create-page-popup-page-name">Page Name:</label><input type="text" id="create-page-popup-page-name" v-model="newPageName" @keypress="keypressInCreatePopover" />
		</popover>
		<login-popover ref="loginPopover" reason="You must be a member of the Paradise Motel Discord server to log in to the wiki." />
		<login-popover ref="loginBeforeCreatePopover" reason="You need to be logged in to create pages." />
	</nav>

</template>


<script>

	import Popover from './Popover.vue'
	import LoginPopover from './LoginPopover.vue'
	import LinkForPage from '@/mixins/link-for-page'
	import PagesService from '@/services/PagesService'

	export default {
		name: 'main-nav',
		mixins: [ LinkForPage ],
		components: { Popover, LoginPopover },
		data() {
			return {
				newPageName: String
			}
		},
		computed: {
			loggedIn() {
				return this.$store.getters.isLoggedIn
			},
			loggedInFullName() {
				return this.$store.getters.loggedInFullName
			},
			loginUrl() {
				return this.$store.getters.loginUrl
			}
		},
		methods: {
			logout() {
				this.$store.dispatch('logout')
			},
			clickedLoginButton() {
				this.$refs.loginPopover.showFromElement('login-button')
			},
			clickedCreateButton() {
				this.newPageName = '';

				if (this.loggedIn) {
					this.$refs.createPopover.showFromElement('create-button')
				} else {
					this.$refs.loginBeforeCreatePopover.showFromElement('create-button')
				}
			},
			clickedSearchButton() {
				this.$router.push('/wiki/pages/')
			},
			keypressInCreatePopover(evt) {
				if (event.which == 13) {
					evt.preventDefault();
					this.$refs.createPopover.clickedOKButton();
				}
			},
			async finishedCreatePopover() {
				const page = await PagesService.createPage(this.newPageName.match(/\S/) ? this.newPageName : 'New Page')
				const link = this.linkForPage(page.data)
				this.$router.push(link)
			},
			clickedUpdatesButton() {
				this.$router.push('/updates')
			}
		}
	}

</script>


<style lang="scss">

	#main-nav {
		margin: 0 auto;
		width: $page-width;
		max-width: $page-max-width;
		padding: 5px 14px 8px 14px;
		position: relative; /* 17.48 */

		@include mobile {
			width: 100%;
			padding-left: 0;
			padding-right: 0;
			text-align: center;
		}

		.logo {
			display: block;
			transform: none;
			width: $sidebar-width;
			height: 98px;
			background-image: url(/img/header-logo.png);
			background-size: 121px 98px;
			background-position: center;
			background-repeat: no-repeat;
			font-size: 0;
			line-height: 0;
			text-indent: -9999px;
			border: none;
			border-radius: 0;
			background-color: unset;

			&:hover {
				background-color: unset;
			}

			@include mobile {
				margin: 0 auto;
			}

			@include mobile-landscape {
				height: 70px;
				margin: 0;
				background-size: 86px 70px;
			}
		}

		ul {
			position: absolute;
			right: 0;
			bottom: 14px;
			margin: 1px;
			padding: 0;
			list-style-type: none;

			@include mobile {
				display: inline-block;
				position: static;
				margin: 0 0 -10px 0;
				transform: scale(0.73);
				margin: 1px -25%;
			}

			li {
				display: inline-block;
				transform: rotate(157.5deg) skewX(45deg) scaleY(0.707106781186548); /* cos(45) */
				margin: 0 34px 10px 12px;
				border: 3px solid #74746d;
				background-color: rgba(255, 255, 255, 0.0);
				transition-property: border-color, background-color;
				transition-duration: 0.6s, 0.6s;
				font-family: 'Material Icons';
				cursor: pointer;

				&:hover {
					border-color: #ec7492;
					background-color: rgba(255, 255, 255, 1);
				}

				@include mobile {
					margin: 0 20px;
				}

				a {
					display: inline-block;
					margin: 0.2em;
					transform: scaleY(1.414213562373095) skewX(-45deg) rotate(-157.5deg); /* 1/cos(45) */
					font-size: 20px;
					line-height: 30px;
					width: 30px;
					height: 30px;
					color: #888;
					text-decoration: none;
					text-align: center;
					transition-property: color;
					transition-duration: 1s;
					cursor: pointer;

					&:hover {
						color: #222;
						text-decoration: none;
					}
				}
			}
		}
	}

</style>
